import { AdminSidebar } from "./AdminSidebar.jsx";

/**
 * Admin layout with persistent sidebar.
 * Each persona sub-page is its own view (not a tab within profile).
 */
export function AdminLayout({
  view,
  personas,
  selectedPersona,
  onSetView,
  onSelectPersona,
  onLogout,
  children,
}) {
  return (
    <div style={{
      display: "flex",
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
    }}>
      <AdminSidebar
        view={view}
        personas={personas}
        selectedPersona={selectedPersona}
        onSetView={onSetView}
        onSelectPersona={onSelectPersona}
        onLogout={onLogout}
      />
      <div style={{
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}>
        {children}
      </div>
    </div>
  );
}
